/**
 * Para onde vai quem o provedor devolve.
 *
 * **A URL de retorno viaja gravada dentro da cobrança** (G-RETURN): o checkout
 * carrega `/configuracoes/plano/sucesso?pedido=...` no momento em que nasce, e
 * um Pix gerado hoje volta por esse endereço semanas depois, quando for pago.
 * Por isso nenhuma rota de retorno pode ser removida quando a tela muda de
 * lugar - ela vira redirecionamento, e o redirecionamento precisa **levar a
 * query junto**, porque é dela que sai o número do pedido que a tela usa para
 * achar o recibo.
 *
 * `null` quer dizer "fica onde está": cancelado e expirado continuam na tela de
 * Plano, que é onde a oferta reabre para quem desistiu no meio.
 */
export function destinoDoRetorno(retorno: string | undefined, search: string): string | null {
  if (retorno !== 'sucesso') return null;
  return `/compra/sucesso${search}`;
}
